import type { ReactNode } from 'react'
import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import type { RootState } from '../../store'

interface ProtectedRouteProps {
    children: ReactNode
    allowedRoles: string[]
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    allowedRoles,
}) => {
    const activeRole = useSelector((state: RootState) => state.auth.activeRole)

    if (!allowedRoles.includes(activeRole as string)) {
        return <Navigate to="/login" replace />
    }

    return <>{children}</>
}

export default ProtectedRoute
